import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/node';

import {GetEmployeeMechanicsApiResponse} from '../types';

const getEmployeeMechanicsV2Mock: GetEmployeeMechanicsApiResponse = [
  {
    employeeId: '31d21f9f-cb3c-4c15-9d17-60b61b4e045a',
    name: 'Frank Hyundai',
    costCenterId: '5fbef3c5-0ec3-4683-9723-261143f40f8e',
  },
  {
    employeeId: '8fae6849-85d8-4d00-a20a-d56cdb7a2e37',
    name: 'Mathew Doe',
    costCenterId: '5fbef3c5-0ec3-4683-9723-261143f40f8e',
  },
  {
    employeeId: '23b354e0-4b85-481b-9a68-244f4018328e',
    name: 'Radek Tester',
    costCenterId: '5fbef3c5-0ec3-4683-9723-261143f40f8e',
  },
  {
    employeeId: '6e01f0ff-4fcd-48ab-82e2-a5f3490cd4f9',
    name: 'Radek Other',
    costCenterId: '30153bb0-0be4-41ab-9d1d-220783d55860',
  },
  {
    employeeId: '7fd9f7cd-7657-42fa-b8fe-e92bc65b1661',
    name: 'John Shared',
    costCenterId: '30153bb0-0be4-41ab-9d1d-220783d55860',
  },
];

const getEmployeeMechanicsV2ResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/core/v2/employee/mechanics*', () => HttpResponse.json(getEmployeeMechanicsV2Mock))
  );

export const metadaCoreEmployeeMechanicsApiMock = {
  getEmployeeMechanicsMock: getEmployeeMechanicsV2Mock,
  getEmployeeMechanicsResponseInterceptor: getEmployeeMechanicsV2ResponseInterceptor,
};
